import React, { useEffect, useState } from 'react';
import { Section } from './layout';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { getAllMeals } from '../redux/actions/meals';
import { Loader, MealsCard } from '../components/utils';
import { motion } from 'framer-motion';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

function RelatedBigMeals({ currentMealId }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isLoading, Allmeals, pagination } = useSelector((state) => state.Meals);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(3);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    dispatch(getAllMeals(page, limit));
  }, [page, limit, dispatch]);

  // Filter out current meal and get random related meals
  const relatedMeals = Allmeals?.filter(meal => meal._id !== currentMealId)?.slice(0, 3) || [];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 100, damping: 15 },
    },
  };

  if (isLoading) {
    return (
      <div className="py-16">
        <Loader />
      </div>
    );
  }

  if (relatedMeals.length === 0) {
    return null;
  }

  return (
    <div className="bg-gradient-to-t from-gray-50 to-white dark:from-n-9 dark:to-n-8 py-16 lg:py-24">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12" // increased margin-bottom
        >
          <h2 className="text-3xl md:text-4xl font-kufi font-bold mb-4 bg-gradient-to-r from-color-1 to-color-2 bg-clip-text text-transparent pb-2">
            {t("you might also like")}
          </h2>
          <p className="text-n-5 body-1 dark:text-n-4 max-w-2xl mx-auto">
            {t("discover other delicious meals from our menu")}
          </p>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {relatedMeals.map((meal, index) => (
            <motion.div
              key={meal._id}
              variants={itemVariants}
              onHoverStart={() => setHoveredIndex(index)}
              onHoverEnd={() => setHoveredIndex(null)}
              className="overflow-visible" // لمنع قص المحتوى
            >
              <MealsCard 
                meals={meal} 
                isHovered={hoveredIndex === index}
              />
            </motion.div>
          ))}
        </motion.div>

        {/* View All Button */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3 }}
          className="text-center mt-12 pt-4" // added padding-top
        >
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => window.location.href = '/AllResturentMeals'}
            className="px-8 py-3 border-2 border-color-1 text-color-1 rounded-full hover:bg-color-1 hover:text-white transition-all duration-300 font-kufi font-normal"
          >
            {t("view all meals")}
          </motion.button>
        </motion.div>
      </div>
    </div>
  );
}

export default RelatedBigMeals;